import { __assign } from '../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import { useWatch } from 'react-hook-form';
import PhoneInputWithCountrySelect, { parsePhoneNumber } from '../../../../_externals/.pnpm/react-phone-number-input@3.4.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-phone-number-input/min/index.js';
import '../../atoms/Icons/Minus/Minus.js';
import '../../atoms/Icons/Plus/Plus.js';
import '../../atoms/Icons/Right/Right.js';
import '../../atoms/Icons/Left/Left.js';
import '../../atoms/Icons/Down/Down.js';
import '../../atoms/Icons/Up/Up.js';
import '../../atoms/Icons/Tick/Tick.js';
import '../../atoms/Icons/Cross/Cross.js';
import '../../atoms/Icons/Hamburger/Hamburger.js';
import '../../atoms/Icons/Search/Search.js';
import '../../atoms/Icons/Cart/Cart.js';
import '../../atoms/Icons/Filter/Filter.js';
import '../../atoms/Icons/Profile/Profile.js';
import '../../atoms/Icons/ProfileCircleOutline/ProfileCircleOutline.js';
import '../../atoms/Icons/LoadingCircle/LoadingCircle.js';
import '../../atoms/Icons/CrossSolidCircleOutline/CrossSolidCircleOutline.js';
import '../../atoms/Icons/RadioButtonOutline/RadioButtonOutline.js';
import '../../atoms/Icons/RadioButtonSolid/RadioButtonSolid.js';
import '../../atoms/Icons/ArrowDownCircleOutline/ArrowDownCircleOutline.js';
import '../../atoms/Icons/MinusCircleOutline/MinusCircleOutline.js';
import '../../atoms/Icons/PlusCircleOutline/PlusCircleOutline.js';
import '../../atoms/Icons/ArrowUpCircleOutline/ArrowUpCircleOutline.js';
import '../../atoms/Icons/InfoSolidCircleOutline/InfoSolidCircleOutline.js';
import '../../atoms/Icons/WarningSolidCircleOutline/WarningSolidCircleOutline.js';
import '../../atoms/Icons/InfoCircleOutline/InfoCircleOutline.js';
import '../../atoms/Icons/WarningCircleOutline/WarningCircleOutline.js';
import '../../atoms/Icons/CrossCircleOutline/CrossCircleOutline.js';
import '../../atoms/Icons/TickCircleOutline/TickCircleOutline.js';
import '../../atoms/Icons/Socials/Facebook/Facebook.js';
import '../../atoms/Icons/Socials/Instagram/Instagram.js';
import '../../atoms/Icons/Socials/Tiktok/Tiktok.js';
import '../../atoms/Icons/Socials/LinkedIn/LinkedIn.js';
import '../../atoms/Icons/Socials/FacebookWithoutCircle/FacebookWithoutCircle.js';
import '../../atoms/Icons/Payments/Visa/Visa.js';
import '../../atoms/Icons/Payments/Mastercard/Mastercard.js';
import '../../atoms/Icons/Payments/Amex/Amex.js';
import '../../atoms/Icons/Payments/ApplePay/ApplePay.js';
import '../../atoms/Icons/Payments/GooglePay/GooglePay.js';
import '../../atoms/Icons/Payments/Stripe/Stripe.js';
import '../../atoms/Icons/Payments/PoweredByStripe/PoweredByStripe.js';
import '../../atoms/Icons/WalletPayment/ApplePayLogoWhite/ApplePayLogoWhite.js';
import '../../atoms/Icons/WalletPayment/ApplePayLogoBlack/ApplePayLogoBlack.js';
import '../../atoms/Icons/WalletPayment/GooglePayLogo/GooglePayLogo.js';
import '../../atoms/Icons/Partners/Ups/Ups.js';
import '../../atoms/Icons/Partners/Trustpilot/Trustpilot.js';
import '../../atoms/Icons/Dot/Dot.js';
import '../../atoms/Flags/Flag.js';
import * as Typography from '../../atoms/Typography/Typography.js';
import '../../atoms/Typography/TypographyStyles.js';
import '../../atoms/Button/ButtonStyles.js';
import '@lacedltd/design-tokens';
import '../../atoms/WalletPaymentButton/WalletPaymentButton.styles.js';
import '../../atoms/Link/Link.styles.js';
import '../../atoms/Switch/Switch.styles.js';
import '../../atoms/GlobalNotification/GlobalNotification.styles.js';
import '../../atoms/Button/Button.js';
import '../../atoms/PremiumLabel/PremiumLabel.styles.js';
import '../../atoms/Tooltip/Tooltip.styles.js';
import '../../atoms/Toast/Toast.styles.js';
import '../../atoms/SiteSettingsButton/SiteSettingsButton.styles.js';
import '../../atoms/Hint/Hint.styles.js';
import '../../atoms/Pictograms/Auth/Auth.js';
import '../../atoms/Pictograms/BoxNew/BoxNew.js';
import '../../atoms/Pictograms/Delivery/Delivery.js';
import '../../atoms/Pictograms/Return/Return.js';
import '../Carousel/Carousel.styles.js';
import createForm from '../Form/index.js';
import '../Footer/Footer.styles.js';
import '../Footer/BottomContent/BottomContent.styles.js';
import '../../molecules/Accordion/Root/Root.styles.js';
import '../../molecules/Accordion/Item/Item.js';
import '../Footer/SiteNavigationLinks/SiteNavigationLinks.styles.js';
import '../Footer/SiteNavigationGroups/SiteNavigationGroups.styles.js';
import '../../molecules/Dialog/Dialog.styles.js';
import '../CookieBanner/SimpleCookieForm/SimpleCookieForm.styles.js';
import '../CookieBanner/ExpandedCookieForm/ExpandedCookieForm.styles.js';
import '../CookieBanner/ExpandedCookieForm/PreferenceItem/PreferenceItem.styles.js';
import { generateSchema } from './AddressForm.schema.js';
import { AddressFormWrap, AddressFormSection, AddressTwoCol, StyledPhoneInput, AddressFormFooter, SubmitButton } from './AddressForm.styles.js';
import AddressSearch from './AddressSearch.js';
import { ieStates, caStates, usStates } from './States.js';
import '../../atoms/LocationReminder/LocationReminder.styles.js';
import '../../atoms/LocationReminder/LocationReminder.schema.js';

var AddressForm = function (_a) {
    var t = _a.t, _b = _a.type, type = _b === void 0 ? "address" : _b, apiKey = _a.apiKey, countries = _a.countries, _c = _a.defaultValues, defaultValues = _c === void 0 ? {} : _c, location = _a.location, onSubmit = _a.onSubmit, onChange = _a.onChange, loading = _a.loading, billing = _a.billing, _d = _a.errors, errors = _d === void 0 ? {} : _d;
    var schema = generateSchema(type, t.errors);
    var AddressForm = createForm(schema);
    var methods = AddressForm.useForm({
        defaultValues: __assign({ province: "", country: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.country) || location }, defaultValues),
    });
    var setError = methods.setError, formState = methods.formState;
    var formErrors = formState.errors;
    var _e = React.useState([]), provinceOptions = _e[0], setProvinceOptions = _e[1];
    var selectedCountry = useWatch({
        control: methods.control,
        name: "country",
    });
    React.useEffect(function () {
        var subscription = methods.watch(function (value) {
            if (onChange)
                onChange(value);
        });
        return function () { return subscription.unsubscribe(); };
    }, [methods, onChange]);
    React.useEffect(function () {
        var resetFields = [
            "lineOne",
            "lineTwo",
            "city",
            "postalcode",
            "province",
        ];
        switch (selectedCountry) {
            case "US":
                setProvinceOptions(usStates);
                break;
            case "CA":
                setProvinceOptions(caStates);
                break;
            case "IE":
                setProvinceOptions(ieStates);
                break;
            default:
                setProvinceOptions([]);
                break;
        }
        if (selectedCountry !== (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.country)) {
            resetFields.forEach(function (field) {
                return methods.resetField(field, { defaultValue: "" });
            });
        }
    }, [defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.country, selectedCountry, methods]);
    React.useEffect(function () {
        Object.entries(errors).forEach(function (_a) {
            var field = _a[0], message = _a[1];
            setError(field, {
                type: "manual",
                message: message,
            });
        });
    }, [errors, setError]);
    var updateAddress = function (address) {
        var lineOneValue = address.Line1;
        var lineTwoValue = address.Line2;
        if (address.Line3 && address.BuildingName) {
            lineOneValue = "".concat(address.Line1, ", ").concat(address.Line2);
            lineTwoValue = address.Line3;
        }
        var addressValues = [
            { name: "lineOne", value: lineOneValue },
            { name: "lineTwo", value: lineTwoValue },
            { name: "city", value: address.City },
            { name: "postalcode", value: address.PostalCode },
        ];
        if (["US", "CA", "IE"].includes(selectedCountry)) {
            addressValues.push({ name: "province", value: address.ProvinceCode });
        }
        addressValues.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            methods.setValue(name, value);
            methods.clearErrors(name);
        });
    };
    var handlePhoneChange = function (phone) {
        var parsedNumber = parsePhoneNumber(phone || "");
        methods.setValue("dialingCode", "+".concat((parsedNumber === null || parsedNumber === void 0 ? void 0 : parsedNumber.countryCallingCode) || ""));
        methods.setValue("phoneNumber", "+".concat((parsedNumber === null || parsedNumber === void 0 ? void 0 : parsedNumber.nationalNumber) || ""));
    };
    return (React.createElement(AddressFormWrap, null,
        React.createElement(AddressForm.Container, { methods: methods, onSubmit: onSubmit },
            React.createElement(AddressFormSection, null,
                t.title && (React.createElement(Typography.Heading, { as: "h4" }, t.title)),
                React.createElement(AddressTwoCol, null,
                    React.createElement(AddressForm.TextInput, { name: "firstName", autoComplete: "given-name", placeholder: t.name.first }),
                    React.createElement(AddressForm.TextInput, { name: "lastName", autoComplete: "family-name", placeholder: t.name.last })),
                React.createElement(AddressForm.SelectInput, { name: "country", values: countries, placeHolder: t.address.country, disabled: billing }),
                React.createElement(AddressSearch, { apiKey: apiKey, location: selectedCountry || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.country) || location, onAddressSelect: updateAddress, placeholder: t.address.search }),
                React.createElement(AddressForm.TextInput, { name: "lineOne", autoComplete: "address-line1", placeholder: t.address.lineOne }),
                React.createElement(AddressForm.TextInput, { name: "lineTwo", autoComplete: "address-line2", placeholder: t.address.lineTwo }),
                React.createElement(AddressTwoCol, null,
                    React.createElement(AddressForm.TextInput, { name: "city", placeholder: t.address.city, autoComplete: "address-level2" }),
                    React.createElement(AddressForm.TextInput, { name: "postalcode", autoComplete: "postal-code", placeholder: t.address.postalcode })),
                selectedCountry && provinceOptions.length > 0 && (React.createElement(AddressForm.SelectInput, { name: "province", values: provinceOptions, placeHolder: t.address.province }))),
            type === "checkout" && (React.createElement(AddressFormSection, null,
                React.createElement(Typography.Heading, { as: "h4" }, t.contact.title),
                React.createElement(AddressForm.TextInput, { name: "email", placeholder: t.contact.email, autoComplete: "email" }),
                React.createElement(StyledPhoneInput, { hasError: !!formErrors.phoneNumber },
                    React.createElement(PhoneInputWithCountrySelect, { placeholder: "0000000000", countries: countries.map(function (c) { return c.value; }), onChange: handlePhoneChange, smartCaret: true, defaultCountry: location }),
                    React.createElement(AddressForm.TextInput, { name: "dialingCode", hidden: true, showError: false }),
                    React.createElement(AddressForm.TextInput, { name: "phoneNumber", hidden: true })))),
            React.createElement(AddressFormFooter, null,
                type === "checkout" && (React.createElement(AddressForm.CheckboxInput, { name: "consent", label: t.contact.consent })),
                React.createElement(SubmitButton, { loading: loading, variant: "primary" }, t.submit)))));
};

export { AddressForm as default };
//# sourceMappingURL=AddressForm.js.map
